// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { Support } from '../../../types/Model';

export interface ReplySupportRequestPayload {
  id: number;
  message: string;
  imagesFiles?: File[]
}

export interface ReplySupportSuccessPayload {
  data: Support;
}

export interface ReplySupportFailPayload {
  error: Error;
}

const replySupportActions = createAsyncAction(
  'elearning/UPDATE_REPLY_SUPPORT_DATA',
  'elearning/UPDATE_REPLY_SUPPORT_DATA_SUCCESS',
  'elearning/UPDATE_REPLY_SUPPORT_DATA_FAIL'
)<
  ReplySupportRequestPayload,
  ReplySupportSuccessPayload,
  ReplySupportFailPayload
>();

export { replySupportActions as default }
